import api from '@/services/api'

export function usageViewId() {
  return typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID() : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2) + '-view'
}

// Count displayed instances, never configuration requests, hidden tabs or editor refreshes.
export function observePageUsage({ element, pageId, profilId, actorType, viewId, canRecord, onRecorded }) {
  if (!element || !pageId || !profilId || Number(actorType) === 3) return () => {}
  let stopped = false, pending = false, observer
  const visible = () => {
    if (document.visibilityState === 'hidden' || !element.isConnected || !element.getClientRects().length) return false
    const style = getComputedStyle(element)
    if (style.visibility === 'hidden' || style.display === 'none') return false
    const rect = element.getBoundingClientRect()
    return rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth
  }
  const cleanup = () => {
    stopped = true
    if (observer) observer.disconnect()
    document.removeEventListener('visibilitychange', check)
    window.removeEventListener('scroll', check, true)
    window.removeEventListener('resize', check)
  }
  const check = () => {
    if (stopped || pending || !canRecord() || !visible()) return
    pending = true
    // Deliberately bypass the UI request queue: statistics never hold up business requests.
    api.post('/engine/page-usage', { page_id: pageId, profil_id: profilId, view_id: viewId })
      .then(response => { if (response.data && response.data.success) onRecorded() })
      .catch(() => {})
      .finally(cleanup)
  }
  if (typeof IntersectionObserver !== 'undefined') {
    observer = new IntersectionObserver(check)
    observer.observe(element)
  }
  document.addEventListener('visibilitychange', check)
  window.addEventListener('scroll', check, true)
  window.addEventListener('resize', check)
  check()
  return cleanup
}
